{
  "da-DK": {
    "model": {
      "profile": {
        "id": "Bruger-id",
        "userName": "Brugernavn",
        "email": "E-mailadresse",
        "emailConfirmed": "E-mail bekræftet",
        "phoneNumber": "Telefonnummer",
        "phoneNumberConfirmed": "Telefonnummer bekræftet",
        "twoFactorEnabled": "To-faktor-godkendelse aktiveret",
        "lockoutEnd": "Slutdato for spærring",
        "lockoutEnabled": "Låsning aktiveret",
        "accessFailedCount": "Antal mislykkede adgangsforsøg",
        "firstName": "Fornavn",
        "lastName": "Efternavn",
        "picture": "Profilbillede",
        "organisationName": "Organisation",
        "name": "Navn",
        "roles": "Roller"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Bekræftet"
      },
      "action": {
        "resetPassword.tooltip": "Send instruktioner til nulstilling af adgangskoden til brugeren via e-mail."
      },
      "message": {
        "resetPassword.success": "En e-mail er blevet sendt til brugeren med instruktioner om, hvordan vedkommende kan nulstille sin adgangskode."
      }
    }
  }
}